const Images = {
    logo: "/train/img/loginHintBlack.png",
    avatar_0: "/train/img/avatar_0.png",
    iconClose: "/train/img/pic_tupianguanbi_n.png",
    exclamation: "/train/img/icon_tishi.png",
    headerImg: "/train/img/header-img.png",
    coins: "/train/img/icon_moshui.png",
    logout: "/train/img/icon_tuichu_n.png",
    modelTheme0: "/train/img/modelTheme0.png",
    modelTheme1: "/train/img/modelTheme1.png",
    modelTheme2: "/train/img/modelTheme2.png",
    modelTheme3: "/train/img/modelTheme3.png",
    emptyDataset: "/train/img/emptyDataset.png",
    newDataset: "/train/img/newDataset.png",
    newDataset1: "/train/img/newDataset1.png",
    videoCount: "/train/img/videoCount.png",
    imgCount: "/train/img/imgCount.png",
    dots: "/train/img/dots.png",
    edit: "/train/img/edit.png",
    copy: "/train/img/copy.png",
    deleteIcon: "/train/img/deleteIcon.png",
    deleteIcon1: "/train/img/deleteIcon1.png",
    deleteIcon2: "/train/img/deleteIcon2.png",
    upload: "/train/img/upload.png",
    add: "/train/img/add.png",
    expand: "/train/img/expand.png",
    exitBatch: "/train/img/exitBatch.png",
    selectAll: "/train/img/selectAll.png",
    publish: "/train/img/publish.png",
    download: "/train/img/download.png",
    mark: "/train/img/mark.png",
    dummy: "/train/img/dummy.png",
    gear: "/train/img/gear.png",
    random: "/train/img/random.png"
};

export default Images;